<template>
  <div class="contracting-party">
    <div class="party-data-box box" v-for="(item, index) in partyData" :key="index" @click="handleActive(index)"
      :class="{ 'active': activeIndex == index }">
      <div class="top">
        <div class="top-left">{{item.name}}</div>
        <div class="top-right">
          <i @click.stop="del(item,activeIndex == index)" class="el-icon-delete"></i>
          <i @click.stop="edit(item)" class="el-icon-edit-outline"></i>
        </div>
      </div>
      <div class="content">
        <div class="content-item">
          <div class="label">身份证号</div>
          <div class="value">{{ item.card_id }}</div>
        </div>
        <div class="content-item">
          <div class="label">电话号码</div>
          <div class="value">{{ item.phone }}</div>
        </div>
        <div class="content-item">
          <div class="label">详细地址</div>
          <div class="value">
            <template v-if="item.country_type == 1">
              {{ item.province }}{{ item.city }}{{ item.area }}{{ item.address }}
            </template>
            <template v-else>
              {{ countryName(item) }}{{ item.address }}
            </template>
          </div>
        </div>
      </div>
      <img v-if="activeIndex == index" class="active-img" src="@/assets/image/Contract/active.png" alt="">
    </div>
    <div class="add box" v-if="partyData.length < 6" @click="edit('')">
      <div>
        <i class="el-icon-plus"></i>
        <div class="text">添加签约人</div>
      </div>
    </div>
    <!-- 删除签约人弹窗 -->
    <myDialog :title="'是否删除签约人信息？'" :btn-text="'确认'" btn :show="delPartyShow" :close-fun="() => {
      delPartyShow = false
    }">
      <div slot="btn" class="confirmReceip-btnGroup">
        <div @click="delPartyShow = false">取消</div>
        <div @click="mydialogBtnClick">确认</div>
      </div>
    </myDialog>
    <!-- 添加编辑签约人 -->
    <el-dialog center title="添加签约信息" :visible.sync="editPartyShow" :before-close="beforeClose" custom-class="edit-party-dia" width="450px">
      <el-form :model="form" label-position="left" label-width="96px" :rules="rules" ref="form">
        <el-form-item label="姓名" prop="name">
          <el-input size="small" :disabled="!!form.id" class="w-298" v-model="form.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="身份证号" prop="card_id">
          <el-input size="small" :disabled="!!form.id" class="w-298" v-model="form.card_id" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="手机号码" prop="phone">
          <el-input size="small" :disabled="!!form.id" class="w-298" v-model="form.phone" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="默认签约人" prop="last_use">
          <el-radio-group v-model="form.last_use">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="联系地址" prop="country_type">
          <el-radio-group v-model="form.country_type" @change="form.country_code = ''">
            <el-radio :label="1">国内</el-radio>
            <el-radio :label="2">国外</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="详细地址" prop="address">
          <div class="domestic" v-if="form.country_type == 1">
            <div class="certContractSign-card-body-form-bottom-content-province province">
              <el-select placeholder="省" class="w-95" v-model="form.province" size="small" clearable filterable
                @change="provinceChange">
                <el-option v-for="item in ChinaAddressArea" :key="item.value" :label="item.value" :value="item.value">
                </el-option>
              </el-select>
              <el-select placeholder="市" class="select w-95" v-model="form.city" size="small" filterable clearable
                @change="cityChange">
                <el-option v-for="item in cityList" :key="item.value" :label="item.value" :value="item.value">
                </el-option>
              </el-select>
              <el-select placeholder="区" class="w-95" v-model="form.area" size="small" filterable clearable>
                <el-option v-for="item in districtList" :key="item.value" :label="item.value" :value="item.value">
                </el-option>
              </el-select>
            </div>
            <el-input placeholder="请输入详细地址" class="certContractSign-card-body-form-bottom-content-address w-298"
              size="small" v-model="form.address" maxlength="30"></el-input>
          </div>
          <div class="abroad" v-else>
            <el-select placeholder="国家" size="small" class="abroad-select w-298" v-model="form.country_code">
              <el-option v-for="(item, index) in countryList" :key="item.en + index" :label="item.name" :value="item.tel">
              </el-option>
            </el-select>
            <el-input placeholder="请输入详细地址" class="certContractSign-card-body-form-bottom-content-address w-298"
              size="small" maxlength="50" v-model="form.address"></el-input>
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <!-- <el-button @click="resetInfo">重填</el-button> -->
        <el-button class="sub" type="primary" :loading="btnLoading" @click="submitEvent">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import myDialog from "@/components/myDialog";
import { addressArea } from '../newMap'
import { signatoryAdd, signatoryEdit, signatoryDetails, signatoryDel, apiContractuserSignVerified } from "../../../request/API";
export default {
  name: 'ContractingParty',
  components: {
    myDialog,
  },
  props: {
    partyData: {
      type: Array,
      default() {
        return []
      }
    },
    countryList: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      btnLoading: false,
      activeIndex: 0,
      delPartyShow: false,
      editPartyShow: false,
      form: {
        name: '',
        card_id: '',
        last_use: 1,
        country_type: 1,
        country_code: '',
        province: '',
        city: '',
        area: '',
        address: '',
        phone: '',
      },
      ChinaAddressArea: addressArea,
      provinceList: [],
      cityList: [],
      districtList: [],
      rules: {
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        card_id: [
          { required: true, message: "请输入身份证号", trigger: "blur" },
          { validator: this.validate, trigger: ['change', 'blur'] }
        ],
        phone: [{ required: true, message: "请输入手机号", trigger: "blur" }],
        last_use: [{ required: true, message: "请选择默认联系人", trigger: "change" }],
        country_type: [{ required: true, message: "请选择联系地址", trigger: "change" }],
        address: [
          { required: true, message: "请完善联系地址", trigger: "blur" },
          {
            min: 5,
            message: "请输入准确现住地址",
            trigger: "blur",
          },
        ],
      },
      // 删除签约人id
      delSignId: '',
      delActive: false,
    }
  },
  methods: {
    beforeClose() {
      this.resetInfo()
      this.editPartyShow = false
    },
    // 国家码转换
    countryName(data) {
      return this.countryList.find(item => item.tel == data.country_code)?.name || ''
    },
    /**
     * @description: 身份证格式验证
     * @param {*} rule
     * @param {*} value
     * @param {*} callback
     * @return {*}
     */
    validate(rule, value, callback) {
      let reg = /^[1-9]\d{5}(18|19|20|(3\d))\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
      if (this.form.id || reg.test(value)) {
        callback()
      } else {
        callback(new Error('身份证号码格式错误!'));
      }
    },
    /**
     * @description: 关闭弹窗获取列表
     * @return {*}
     */
    handleClose() {
      this.beforeClose()
      this.$emit('refreshData')
      if(this.delActive){
        this.delActive = false
        this.handleActive(0)
      }
    },
    /**
     * @description: 选中
     * @param {*} index
     * @return {*}
     */
    handleActive(index) {
      this.activeIndex = index
      this.$emit('handleActive',{id: this.partyData[this.activeIndex].id, index})
    },
    /**
     * @description: 提交
     * @return {*}
     */
    submitEvent() {
      if (this.form.country_type == 2) {
        this.form.province = ''
        this.form.city = ''
        this.form.area = ''
        if (this.form.country_code == '') {
          this.$message({
            message: '请选择国家',
            center: true,
            offset: 200,
            customClass: 'sell-contract-msg'
          })
          return
        }
      } else {
        if (this.form.province == '') {
          this.$message({
            message: '请选择省份',
            center: true,
            offset: 200,
            customClass: 'sell-contract-msg'
          })
          return
        } else if (this.form.city == '' && this.cityList.length > 0) {
          this.$message({
            message: '请选择城市',
            center: true,
            offset: 200,
            customClass: 'sell-contract-msg'
          })
          return
        } else if (this.districtList.length > 0 && this.form.area == '') {
          this.$message({
            message: '请选择区县',
            center: true,
            offset: 200,
            customClass: 'sell-contract-msg'
          })
          return
        }
        this.form.country_code = '86'
      }
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.btnLoading = true
          apiContractuserSignVerified(1,{
            cert_name: this.form.name,
            cert_id: this.form.card_id
          }).then(res => {
            if(this.form.id){
              signatoryEdit({
                client: 'front',
                ...this.form
              }).then(res => {
                this.handleClose()
                this.btnLoading = false
                setTimeout(this.resetInfo(),200)
              }).catch(err => {
                this.btnLoading = false
                this.$message({
                  message: err.msg,
                  center: true,
                  offset: 200,
                  customClass: 'sell-contract-msg'
                })
              })
            } else {
              signatoryAdd({
                client: 'front',
                ...this.form
              }).then(res => {
                this.handleClose()
                this.btnLoading = false
              }).catch(err => {
                this.btnLoading = false
                this.$message({
                  message: err.msg,
                  center: true,
                  offset: 200,
                  customClass: 'sell-contract-msg'
                })
              })
            }
          }).catch(e => {
            this.btnLoading = false
            this.$message({
              message: e.msg,
              center: true,
              offset: 200,
              customClass: 'sell-contract-msg'
            })
          })
        } else {
          this.$message({
            message: '请正确填写相关信息',
            center: true,
            offset: 200,
            customClass: 'sell-contract-msg'
          })
        }
      })
    },
    /**
     * @description: 重置
     * @return {*}
     */
    resetInfo() {
      // this.$refs.form.resetFields()
      this.form = {
        name: '',
        card_id: '',
        country_type: 1,
        country_code: '',
        province: '',
        city: '',
        area: '',
        address: '',
        phone: '',
        last_use: '',
      }
      this.$nextTick(() => {
        this.$refs.form.clearValidate()
      })
    },
    /**
     * @description: 删除签约人弹窗
     * @return {*}
     */
    del(item,flag) {
      this.delPartyShow = true
      this.delSignId = item.id
      this.delActive = flag
    },
    /**
     * @description: 添加/编辑签约人
     * @return {*}
     */
    edit(item) {
      if (item != '') {
        signatoryDetails({
          client: 'front',
          sign_id: item.id
        }).then(res => {
          this.form = res.data
          this.form.id = item.id
          const { province, city } = this.form
          this.cityList = this.ChinaAddressArea.find(item => item.value == province)?.children || []
          this.districtList = this.cityList.find(item => item.value == city)?.children || []
        })
      }
      this.editPartyShow = true
      this.$nextTick(() => {
        this.$refs.form.clearValidate()
      })
    },
    /**
     * @description: 删除签约人
     * @return {*}
     */
    mydialogBtnClick() {
      signatoryDel({
        client: 'front',
        sign_id: this.delSignId
      }).then(res => {
        this.$message({
          message: '删除成功',
          center: true,
          offset: 200,
          customClass: 'sell-contract-msg'
        })
        this.handleClose()
      }).catch(err => {
        this.$message({
          message: '删除失败',
          center: true,
          offset: 200,
          customClass: 'sell-contract-msg'
        })
      })
      this.delPartyShow = false
    },
    provinceChange(e, flag) {
      if (e == '') {
        this.cityList = []
      } else {
        this.cityList = this.ChinaAddressArea.filter(item => item.value == e)[0].children || []
        this.districtList = []
      }
      if (flag) {
        this.cityChange(this.form.city, true)
      } else {
        this.form.city = ''
        this.form.area = ''
      }
    },
    cityChange(e, flag) {
      if (e == '') {
        this.districtList = []
      } else {
        this.districtList = this.cityList.filter(item => item.value == e)[0].children || []
      }
      if (flag) { } else {
        this.form.area = ''
      }
    },
  },
}
</script>

<style lang="less" scoped>
.contracting-party {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;

  .box {
    width: 280px;
    height: 191px;
    background: #FFFFFF;
    border-radius: 4px;
    border: 1px solid #DEE3EC;
    box-sizing: border-box;
    padding: 25px 20px 28px;
    margin-right: 40px;
  }

  .add {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #DEE3EC;
    text-align: center;

    .el-icon-plus {
      font-size: 80px;
    }

    >div {
      font-size: 12px;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 400;

      .text {
        margin-top: 10px;
      }
    }
  }

  .party-data-box {
    margin-bottom: 40px;
    cursor: pointer;

    .top {
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-bottom: 1px solid #DEE3EC;
      padding-bottom: 10px;

      &-left {
        font-size: 16px;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #333333;
      }

      &-right {
        color: #333333;

        i {
          margin-left: 15px;
          cursor: pointer;

          &:hover {
            color: #F0EDE8;
          }
        }
      }
    }

    .content {
      padding-top: 4px;

      &-item {
        display: flex;
        align-items: flex-start;
        justify-content: flex-start;
        margin-top: 8px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;

        .label {
          min-width: 56px;
          margin-right: 14px;
          font-size: 14px;
          color: #999999;
        }

        .value {
          font-size: 14px;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }
      }
    }
  }

  .active {
    border: 1px solid var(--primary);
    position: relative;

    .active-img {
      position: absolute;
      bottom: 0;
      right: 0;
      width: 25px;
      height: 22px;
    }
  }
}

.confirmReceip-btnGroup {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 30px;

  div {
    font-size: 16px;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 500;
    color: #000000;
    width: 138px;
    height: 38px;
    border-radius: 3px;
    opacity: 1;
    border: 1.5px solid var(--bg-dark);
    color: var(--text-main);
    cursor: pointer;
    user-select: none;
    text-align: center;
    line-height: 38px;
  }

  div:last-of-type {
    background: var(--primary);
    border: 1.5px solid var(--primary);
    color: #FFF;
    margin: 0 0 0 15px;

    &:hover {
      background: var(--primary-hover);
      border-color: var(--primary-hover);
    }
  }
}

/deep/ .tipDialog #tipDialog .title {
  font-size: 18px;
  color: #333333;
}

/deep/ .tipDialog #tipDialog .text {
  margin: 39px 0 0;
}

/deep/.edit-party-dia {
  border-radius: 4px;

  .w-298 {
    width: 298px;
  }

  .w-95 {
    width: 95px;
  }

  .select {
    margin: 0 6px 0;
  }

  .el-dialog__title {
    font-size: 16px;
    font-family: PingFang SC-Semibold, PingFang SC;
    font-weight: 600;
    color: #333333;
  }

  .el-dialog__body {
    padding-bottom: 0 !important;
  }

  .el-form-item__label {
    font-size: 14px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
  }

  .dialog-footer {
    .el-button {
      width: 148px;
      height: 28px;
      line-height: 28px;
      border-radius: 3px;
      padding: 0;
      border: 1.5px solid var(--bg-dark);
      font-size: 14px;
      font-family: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      color: var(--text-main);
    }

    .sub {
      background: var(--primary);
      border: 1.5px solid var(--primary);
      color: #FFF;
      margin-left: 18px;

      &:hover {
        background: var(--primary-hover);
        border-color: var(--primary-hover);
      }
    }
  }

  .el-dialog__footer {
    padding-bottom: 30px;
  }
}
</style>
